import styled from '@emotion/styled';

export const Contact = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  background-color: #302f2f;
  border-radius: 12px;
`;

export const ContactName = styled.p`
  font-size: 1.07rem;
`;

export const Number = styled.span`
  font-weight: 500;
  color: #358df2;
`;
